import React, { useState, useEffect } from "react";

const IsLoaded = ({ children }: { children: React.ReactNode }) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => setLoaded(true), []);

  return <>{loaded && <>{children}</>}</>;
};

export default IsLoaded;
